import sha1 from "sha1";

export function getThirdPartyHash(prop) {
    return sha1(process.env.VUE_APP_THIRD_PARTY_SALT+prop)
}
